export const GITHUB_URL = 'https://github.com/ribeirogab/zeno-agent';
export const ROADMAP_URL = `${GITHUB_URL}/blob/main/ROADMAP.md`;
export const LICENSE_URL = `${GITHUB_URL}/blob/main/LICENSE`;
export const DOCS_URL = 'https://docs.zeno-agent.dev';
export const INSTALL_BASE = 'curl -fsSL https://zeno-agent.dev/install.sh';
export const INSTALL_CMD = `${INSTALL_BASE} | sh`;
export const INSTALL_CMD_UNSTABLE = `${INSTALL_BASE} | sh -s -- --unstable`;
